import React from "react";
import PropTypes from "prop-types";

import Icon from "../Icon";

function NextArrow(props) {
  const { className, style, onClick } = props;
  const baseClassName = "PostCarousel-button PostCarousel-button--next";

  function showPrevArrow() {
    const getPrev = document.querySelector(".slick-prev");
    getPrev.classList.remove("hide-on-load");
  }

  return (
    <button
      className={`${className} ${baseClassName}`}
      style={{ ...style }}
      type="button"
      onClick={run => {
        onClick(run);
        showPrevArrow(run);
      }}
    >
      <span className="u-screenreader">Next</span>
      <Icon name="chevronLeft" height={40} width={20} />
    </button>
  );
}

NextArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
};

export default NextArrow;
